import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Phone, Mail, ArrowRight } from "lucide-react";
export default function ContactCTA() {
  return <section id="contactcta" className="bg-secondary text-secondary-foreground py-20 md:py-24">
      <div className="container mx-auto px-4 max-w-4xl text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default mb-6 tracking-tight">
          ¿Listo para mejorar tus resultados académicos?
        </h2>
        
        <p className="text-lg md:text-xl text-secondary-foreground/80 font-sans mb-10 max-w-2xl mx-auto">Únete a nuestra academia y descubre un método de enseñanza adaptado a tus necesidades.&nbsp; Contacta con nosotros hoy mismo y da el primer paso hacia el éxito.</p>

        <div className="flex flex-col items-center gap-10">
          <Button asChild size="lg" className="rounded-lg text-secondary font-bold text-base px-8 h-14 hover:bg-primary/90 transition-colors">
            
          </Button>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-12 text-secondary-foreground/90">
            <div className="flex items-center gap-3 group">
              <div className="flex items-center justify-center size-10 rounded-full bg-secondary-foreground/10 group-hover:bg-primary/20 transition-colors">
                <Phone className="size-5 text-primary" />
              </div>
              <span className="font-medium font-sans text-lg">610 74 30 69</span>
            </div>
            
            <div className="flex items-center gap-3 group">
              <div className="flex items-center justify-center size-10 rounded-full bg-secondary-foreground/10 group-hover:bg-primary/20 transition-colors">
                <Mail className="size-5 text-primary" />
              </div>
              <span className="font-medium font-sans text-lg">centrocosmos@gmail.com</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}